import React from 'react';
import { SectionFolder } from '@src/components/SectionFolder';
import { SectionTitle } from '@src/components/SectionTitle';
import { SectionProps } from '../types/Settings';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import { FORM_LINE_TITLE_SIZE, SECTION_TITLE_SIZE } from '../utils/variables';
import { SectionContent } from '../subcomponents/SectionContent';
import { createChangeSettings } from '../utils/createChangeSettings';
import { MobilePlayerSelector } from '../selectors/MobilePlayerSelector';
import { WidgetView } from 'common';
import { FormLine } from '@src/components/Form/FormLine';
import { MobilePlayerProductCTASelector } from '../selectors/MobilePlayerProductCTASelector';
import { MobilePlayerIcon } from '../../Icons/DropDownIcons/MobilePlayer';
import { CheckboxNote } from '../subcomponents/CheckboxNote';
import { ADALONG_COLORS } from '@src/styles';
import { Tooltip } from '@mui/material';
import { InfoSvgIcon } from '@src/components/SvgIcons/Info';
import { style } from 'typestyle';

const MobilePlayer = ({ opened, onOpen, editedWidget, setEditedWidget }: SectionProps) => {
  const changeSettings = createChangeSettings(editedWidget, setEditedWidget);

  const handleMobilePlayerChange = <K extends keyof WidgetView['settings']>(
    key: K,
    value: WidgetView['settings'][K],
  ) => {
    if (value === editedWidget.settings[key]) {
      return;
    }
    changeSettings({ [key]: value });
  };

  return (
    <SectionFolder
      title={
        <SectionTitle size={SECTION_TITLE_SIZE}>
          <MobilePlayerIcon />
          {lang.title.main}
        </SectionTitle>
      }
      opened={opened}
      afterTitle={
        <Tooltip title={lang.tooltips.mobilePlayer} placement="top">
          <span className={infoMobilePlayerClass}>
            <InfoSvgIcon />
          </span>
        </Tooltip>
      }
      onOpen={onOpen}
    >
      <SectionContent>
        <FormLine title={lang.title.mobilePlayer} size={FORM_LINE_TITLE_SIZE}>
          <MobilePlayerSelector
            mobile_player_display={editedWidget.settings.mobile_player_display}
            onChange={(value) => handleMobilePlayerChange('mobile_player_display', value)}
          />
        </FormLine>

        {editedWidget.settings.mobile_player_display ? (
          <>
            <FormLine title={lang.title.productCTA} size={FORM_LINE_TITLE_SIZE}>
            <CheckboxNote marginBottom={8} fontSize={11} color={ADALONG_COLORS.LIGHT_GRAY}>
              {lang.notes.productCTA}
            </CheckboxNote>
              <MobilePlayerProductCTASelector
                mobile_player_product_cta={editedWidget.settings.mobile_player_product_cta}
                onChange={(value) => handleMobilePlayerChange('mobile_player_product_cta', value)}
              />
            </FormLine>
          </>
        ) : null }
      </SectionContent>
    </SectionFolder>
  );
};

const lang = LocalizedStrings({
  en: {
    title: {
      main: 'Mobile Player',
      mobilePlayer: 'Media player',
      productCTA: 'Product CTA',
    },
    tooltips: {
      mobilePlayer: 'Configure how media is displayed and interacted with on mobile devices',
    },
    notes: {
      productCTA: '*Only applied if "Shop this look" is not "none"'
    }
  },
});

const infoMobilePlayerClass = style({
  marginLeft: 10,
  color: ADALONG_COLORS.LIGHT_GRAY,
});

export default MobilePlayer;
